<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <!-- <img class="logo-icon" src="assets/images/logos/qualisys-sidebar.svg"> -->
        <span class="logo-text secondary-text">{{'App.NAME' | translate}}</span>
    </div>

    <div class="buttons">

        <button id="toggle-sidebar" mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()"
            fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button id="back" mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <!-- <div class="h3 username" id="name">{{(authData$ | async)?.name}}</div>
        <div class="h5 email hint-text mt-8" id="username">{{(authData$ | async)?.username}}</div> -->
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/logos/qualisys.svg">
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>

<div class="navbar-bottom" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
    <div class="footer-text">
        <span>{{'App.POWERED_BY' | translate}} </span>
        <a href="https://www.sama-consulting.com" target="_blank">{{'App.ENTREPRISE' | translate}}</a>
    </div>
</div>